var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgramming = function SvgProgramming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#programming_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1316CF",
    d: "M14.236 2.647H2.764A2.267 2.267 0 0 0 .5 4.912v7.176a2.267 2.267 0 0 0 2.264 2.265h11.472A2.267 2.267 0 0 0 16.5 12.09V4.912a2.267 2.267 0 0 0-2.264-2.265M6.306 6.25 3.925 8.632l2.119 2.118a.468.468 0 1 1-.663.663l-2.45-2.45a.47.47 0 0 1 0-.663l2.713-2.713a.469.469 0 0 1 .664.663zm3.867-1.103-2.479 7.018a.469.469 0 1 1-.884-.312l2.48-7.018a.469.469 0 1 1 .883.312M14.07 8.7l-2.713 2.713a.469.469 0 0 1-.664-.663l2.383-2.382-2.119-2.118a.469.469 0 1 1 .663-.663l2.45 2.45a.47.47 0 0 1 0 .663"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "programming_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h16v16H.5z"
  })))));
};
export default SvgProgramming;